import React, { memo, ReactNode } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

export const Option = memo<{ name: string; children: ReactNode }>((props) => (
  <div className={cn('font-regular-base', styles.option)}>
    <div className={cn('mt-2', styles.optionName)}>{props.name}</div>
    <div>{props.children}</div>
  </div>
));
